import { FunctionComponent } from 'react'
import RecentMatchOutcomesComponent from '@components/RecentMatchOutcomes'
import { validMatchId, validTypeOfSport } from '@hooks/useRecentMatchOutcomes'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'

type RecentMatchOutcomesProps = {
  title: string
  matchId: string
  typeOfSport: 'soccer'
}

const RecentMatchOutcomes: FunctionComponent<RecentMatchOutcomesProps> = ({
  title,
  typeOfSport,
  matchId,
}) => {
  if (!validMatchId(matchId)) {
    return null
  }
  if (!validTypeOfSport(typeOfSport)) {
    return null
  }

  if (!title) {
    return null
  }

  return (
    <RecentMatchOutcomesComponent
      title={title}
      typeOfSport={typeOfSport}
      matchId={matchId}
    />
  )
}

const widget = {
  kind: ['recent-match-outcomes'],
  component: RecentMatchOutcomes,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
